import { CheckPasswordInterfaceState, initialCheckPasswordState } from '../state/check-password.state';
import { CheckPasswordActions, ECheckPasswordActions } from '../actions/check-password.actions';

export function checkPasswordReducer(state: CheckPasswordInterfaceState = initialCheckPasswordState, action: CheckPasswordActions): CheckPasswordInterfaceState {
  switch (action.type) {
    case ECheckPasswordActions.UpdateCheckPasswordVisibility: {
      return { ...state, result: action.payload };
    }

    default:
      return state;
  }
};
